import { render, staticRenderFns } from "./ordersCard.vue?vue&type=template&id=1ef796d2&"
import script from "./ordersCard.vue?vue&type=script&lang=js&"
export * from "./ordersCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports